$(document).ready(function(){
    if ($(window).width() < 990) {
        $(".block_our-commit-blocks-count-inner").slick({
            speed: 9000,
            autoplay: true,
            autoplaySpeed: 0,

            cssEase: 'linear',
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            arrows: false,
            swipeToSlide: true,
            centerMode: true,
            focusOnSelect: true,
            responsive: [  
              {
                breakpoint: 749,
                settings:{
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                }
              }
            ]
        });
    }
})